import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { AssetModalContentDesktopLayout } from "~/components/AssetModalV2/AssetModalContentDesktopLayout";
import { AssetModalDesktopLayout } from "~/components/AssetModalV2/AssetModalDesktopLayout";
import { ContentHeader } from "~/components/AssetModalV2/Content/Header/ContentHeader";
import { PublicInfoPanel } from "~/components/AssetModalV2/InfoPanel/PublicAssetInfoPanel";
import { TemporaryAssetModalContent, TemporaryAssetModalContentFooter, TemporaryAssetModalLeftPanel } from "~/components/AssetModalV2/TemporaryPlaceholderLayout";
import { PublicAssetHeader } from "./Header/PublicAssetHeader";
export const PublicAssetModalDesktopLayout = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(AssetModalDesktopLayout, {
        header: /*#__PURE__*/ _jsx(PublicAssetHeader, {}),
        rightPanel: /*#__PURE__*/ _jsx(PublicInfoPanel, {}),
        content: /*#__PURE__*/ _jsx(AssetModalContentDesktopLayout, {
            header: /*#__PURE__*/ _jsx(ContentHeader, {}),
            leftPanel: /*#__PURE__*/ _jsx(TemporaryAssetModalLeftPanel, {}),
            footer: /*#__PURE__*/ _jsx(TemporaryAssetModalContentFooter, {}),
            content: /*#__PURE__*/ _jsx(TemporaryAssetModalContent, {})
        })
    });
});
PublicAssetModalDesktopLayout.displayName = "PublicAssetModalDesktopLayout";
